// extracted by mini-css-extract-plugin
module.exports = {"cardArtLink":"purify_cardArt__cardArtLink--2s3ZK"};